var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-wrap",attrs:{"id":"home-section"}},[(_vm.$route.meta.showNavbar)?_c('NavBar'):(_vm.$route.meta.showMainNavbar)?_c('MainNavBar'):_vm._e(),_c('router-view'),(_vm.$route.meta.showFooter)?_c('FooterBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }